//ConfirmPassword.js

import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import apiClient from '../../api/apiClient';
// import axios from 'axios';

import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

const ConfirmPassword = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const token = location.state?.token;

    const [password, setPassword] = useState('');
    const [ConfirmPassword, setConfirmPassword] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            setIsSubmitting(true)
            const response = await apiClient.post(`/login/set_adminpassword`,
                {
                    password: password,
                    confirmPassword: ConfirmPassword,
                },
                {
                    headers: {
                        'Authorization': token,
                        'Content-Type': 'application/json',
                    },
                }
            );
            if (response.data.Status === "SUCCESS") {
                toast.success(response.data.message);
                navigate('/login');
                console.log("set pass sussefully")
            }
            else {
                console.log("set pass faled")
                toast.error(response.data.message);
            }

        } catch (error) {
            console.error(" CATCH Error Password:", error.response ? error.response.data : error.message);
            toast.error( error.response ? error.response.data.message : error.message);
        }
        finally{
            setIsSubmitting(false)

        }
    };

    return (
        <>

        <div className="col-xxl-3 col-lg-4 col-md-5">
            <div className="auth-full-page-content d-flex p-sm-5 p-4">
                <div className="w-100">
                    <div className="d-flex flex-column h-100">
                        <div className="mb-1 mb-md-1 text-center">
                            <a href="index.html" className="d-block auth-logo">
                                <img src="assets/images/MMB_LOGO/MMB_LOGO.png" alt="" height={30} />{" "}
                                <span className="logo-txt">MMB</span>
                            </a>
                        </div>
                        <div className="auth-content my-auto">
                            <div className="text-center">
                                <h5 className="mb-0">Create New Password !</h5>

                            </div>
                            <form className="mt-4 pt-2">
                                <div className="mb-3">
                                    <label className="form-label">Password</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        maxLength={10}
                                        id="username"
                                        placeholder="Enter password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Confirm Password</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        maxLength={10}
                                        id="username"
                                        placeholder="Enter ConfirmPassword"
                                        value={ConfirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                    />
                                </div>


                                <div className="row mb-4">
                                    <div className="col">

                                    </div>
                                </div>
                            </form>
                            <div className="mb-3">
                                <button
                                    className="btn btn-primary w-100 waves-effect waves-light"
                                    type="button" onClick={handleLogin}
                                    disabled={isSubmitting} // Disable button when isSubmitting is true
                                >
                                    {isSubmitting ? 'Processing...' : 'Submit'}
                                    
                                </button>
                            </div>

                            {/* <div className="mt-4 pt-2 text-center">
                      <div className="signin-other-title">
                        <h5 className="font-size-14 mb-3 text-muted fw-medium">
                          - Sign in with -
                        </h5>
                      </div>
                      <ul className="list-inline mb-0">
                        <li className="list-inline-item">
                          <a
                            href="javascript:void()"
                            className="social-list-item bg-primary text-white border-primary"
                          >
                            <i className="mdi mdi-facebook" />
                          </a>
                        </li>
                        <li className="list-inline-item">
                          <a
                            href="javascript:void()"
                            className="social-list-item bg-info text-white border-info"
                          >
                            <i className="mdi mdi-twitter" />
                          </a>
                        </li>
                        <li className="list-inline-item">
                          <a
                            href="javascript:void()"
                            className="social-list-item bg-danger text-white border-danger"
                          >
                            <i className="mdi mdi-google" />
                          </a>
                        </li>
                      </ul>
                    </div> */}


                        </div>
                        <div className="mt-4 mt-md-5 text-center">
                            <p className="mb-0">
                                © MMB . Crafted with{" "}
                                <i className="mdi mdi-heart text-danger" /> by Themesbrand
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            {/* end auth full page content */}
        </div>
        </>
    );
};

export default ConfirmPassword;
